import Chart from 'chart.js/auto';

const BarChart = () => {
    let charts = [];

    const initCharts = () => {
        // Destroy any existing charts
        charts.forEach(({ chart }) => chart.destroy());
        charts = [];

        // Find all bar-chart blocks
        const barBlocks = document.querySelectorAll('.bar-chart');
        if (!barBlocks.length) return;

        barBlocks.forEach((block) => {
            // 1) Parse our ACF data
            const bars = JSON.parse(block.dataset.bars);
            const chartHeading = block.dataset.chartHeading || '';

            // 2) Extract labels and three series of values
            const labels = bars.map((row) => row.label);
            const scopeOne = bars.map((row) => parseFloat(row.scope_one));
            const scopeTwo = bars.map((row) => parseFloat(row.scope_two));
            const scopeThree = bars.map((row) => parseFloat(row.scope_three));

            // 3) Find our canvas
            const canvas = block.querySelector('.bar-chart__canvas');

            // Set canvas height dynamically based on screen width
            if (window.innerWidth < 600) {
                canvas.height = 250;
            } else if (window.innerWidth < 1024) {
                canvas.height = 600;
            } else {
                canvas.height = 600;
            }

            const ctx = canvas.getContext('2d');

            // 4) Build the chart
            const chart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels,
                    datasets: [
                        {
                            label: 'Scope 1',
                            data: scopeOne,
                            backgroundColor: '#1f1333',
                            borderSkipped: false,
                        },
                        {
                            label: 'Scope 2',
                            data: scopeTwo,
                            backgroundColor: '#d3befc',
                            borderSkipped: false,
                        },
                        {
                            label: 'Scope 3',
                            data: scopeThree,
                            backgroundColor: '#7f5aff',
                            borderRadius: { topLeft: 8, topRight: 8 },
                            borderSkipped: false,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false, // Allow manual height control
                    plugins: {
                        title: {
                            display: !!chartHeading,
                            text: chartHeading,
                            font: {
                                family: 'Cy',
                                size: 20,
                            },
                            color: '#280B3D',
                            padding: { bottom: 40 },
                        },
                        legend: {
                            position: 'bottom',
                            labels: {
                                usePointStyle: true,
                                pointStyle: 'rectRounded',
                                padding: 16,
                                font: {
                                    family: '"Albert Sans", sans-serif',
                                    size: window.innerWidth >= 1024 ? 16 : 12,
                                },
                            },
                        },
                    },
                    scales: {
                        x: {
                            stacked: true,
                            grid: { display: false },
                            ticks: {
                                color: '#280B3D',
                                font: {
                                    family: '"Albert Sans", sans-serif',
                                    size: 18,
                                },
                            },
                        },
                        y: {
                            stacked: true,
                            beginAtZero: true,
                            title: {
                                display: true,
                                text: 'Tonnes CO₂e',
                                color: '#280B3D',
                                font: {
                                    family: '"Albert Sans", sans-serif',
                                    size: 18,
                                    weight: 500,
                                },
                            },
                            ticks: {
                                color: '#280B3D',
                                font: {
                                    family: '"Albert Sans", sans-serif',
                                    size: 12,
                                },
                            },
                            grid: {
                                color: (ctx) => (ctx.tick.value === 0 ? '#000' : '#ddd'),
                            },
                        },
                    },
                },
            });

            charts.push({ chart, block });
        });
    };

    document.addEventListener('DOMContentLoaded', () => {
        initCharts();
    });

    window.addEventListener('resize', () => {
        clearTimeout(window.__barChartResizeTimer);
        window.__barChartResizeTimer = setTimeout(() => {
            initCharts();
        }, 300);
    });
};

export default BarChart;
